import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import dayjs from '../../utils/dayjs-setup';
import { useEffect, useState } from "react";
import { ModalDialogConfig } from "../modals/modal-config-prod";


/**
 * @param items array de valores confomado por {key,value} type [string,string]    
 * @param typeView si el tipo de vista es horizontal o vertical 
 * @returns component
 */
export const SubItemTable = ({items=[],typeView='horizontal',cols=[],...props})=>{

    if (items.length === 0){
        return <></>;
    }
  
   return (<Table>
        <TableBody>

    {
        typeView === 'horizontal'?
        <>
        {
        cols.map((col)=> <TableRow  key={col.label}>
          {
            !props.removeHeader &&  <TableCell  key={col.label} ><Typography variant="subtitle2" >{col.label}</Typography></TableCell>
          }
           
           {
            items.map( item=> <TableCell key={item[col.keyRow]} ><Typography variant="caption" >{ !!col.format? "$ "+col.format(item[col.valueKey]):item[col.valueKey]}</Typography></TableCell> )
           }
           
         </TableRow>)
        }
         </>
        
        :<>
        <TableRow>
          {
            !props.removeHeader && cols.map( col=><TableCell key={col.label} >
                     <Typography variant="subtitle2"  >{col.label}</Typography>
                </TableCell> )
          }
        </TableRow>
        { items.map( item=> 
        <TableRow key={item.cod} >
           {cols.map( col=><TableCell key={item[col.keyRow]} ><Typography variant="caption" > { !!col.format? "$ "+col.format(item[col.valueKey]):item[col.valueKey]}</Typography></TableCell> )}        
       </TableRow> )}
       
        <TableRow>

        </TableRow>
        </>
       }
        </TableBody>
   </Table>

   
      )
  
  }


  
/**
 * @param items array de valores confomado por {key,value} type [string,string]    
 * @param typeView si el tipo de vista es horizontal o vertical 
 * @returns component
 */
export const SubItemTableNecesidades = ({items=[],typeView='horizontal',cols=[],...props})=>{

  if (items.length === 0){
      return <></>;
  }

 return (<Table  >
      <TableHead>
      <TableRow  >
        {
          items.map( item=><TableCell key={item.cod} >
             <Table border={1} >
              <TableBody>
                <TableRow>
                {
              cols.map((col)=>  
              <TableCell sx={{width:'110px'}}  key={item[col.keyRow]} >{ !!col.format? col.format(item[col.valueKey]):item[col.valueKey]}</TableCell>
              ) 
            }
                </TableRow>
              </TableBody>
             </Table>
          </TableCell> )
        }
      </TableRow>
     
      </TableHead>
 </Table>

 
    )

}

export const SubItemTableComprasProductos = ({items=[],typeView='horizontal',onSaveProductInput,cols=[],...props})=>{

  const [dataForm,setDataForm] = useState([]);
  const [isOpenedModal,setIsOpenedModal] = useState(false);
  const [openedIndex,setOpenedIndex] = useState(null);
  
  useEffect(()=>{
    console.log({
      propData:props
    });
    console.log("data input",props.value);
      const dataSet  = props.value.map( (ruta,r_index)=>({
      centro_operacion:ruta.centro_op_cod?{value:ruta.centro_op_cod,ruta,label:ruta.centro_op_nombre}:undefined,
      bodega:ruta.bodega_cod?{value:ruta.bodega_cod,label:ruta.bodega_nombre}:null,
      fecha_entrega: ruta.fecha_entrega_oc?dayjs(ruta.fecha_entrega_oc):null,
      cantidad:ruta.total_comprado?ruta.total_comprado:undefined,
      cantidad_um:ruta.total_comprado_um?ruta.total_comprado_um:undefined,
      parentIndex:props.item_index,
      child_index:r_index,
      cotizacion_id:props.item?.cotizacion_cod

    }));
    console.log({dataSet,newvals:props.value});
    setDataForm( dataSet);

   },[]);
  if (items.length === 0){
      return <></>;
  }
  const onChangeForm = (index,key,value)=>{
      let copydata = [...dataForm];
      if ( key === 'cantidad_um'  ){
        const pesoNecesidad = Number(props.value[index]?.peso_necesidad || props.item?.peso_necesidad || 0);
        const cantidadUm = value === '' || value === null || value === undefined ? 0 : Number(value);
        const cantidadSegura = Number.isNaN(cantidadUm) ? 0 : cantidadUm;
        const cantidadKg = pesoNecesidad > 0 ? cantidadSegura * pesoNecesidad : cantidadSegura;
        copydata[index]["cantidad"] = cantidadKg;
        copydata[index]["cantidad_um"] = value;
        setDataForm(copydata);
        if (typeof props.onChangeCantidad === 'function') {
          props.onChangeCantidad(props.principal_index, index, cantidadKg, cantidadSegura);
        }
      }else{
        copydata[index][key] = value;
        setDataForm(copydata);
      }
     
  }
  const onOpenDialog = (child_index)=>{
    setOpenedIndex(child_index);
    setIsOpenedModal(true);
  }
  const SaveConfigData =(data)=>{
   
    onSaveProductInput(openedIndex,props.principal_index,{dataForm});
  }
 
 return (<>
{
isOpenedModal && 
<ModalDialogConfig 
  currentConfig={openedIndex !== null?dataForm[openedIndex]:{} }

  openedModal={isOpenedModal} 
  setOpenedModal={setIsOpenedModal} 
  onSaveModalConfirm={(data_save)=>SaveConfigData(data_save)}
  onChangeForm={(key,value)=>onChangeForm(openedIndex,key,value)}
  /> 
  }
 <Table border={1} >
      <TableHead>
      <TableRow  >
       {
          items.map( (item,child_index)=><TableCell sx={{border:"none"}}  key={item.destino} >
             <Table border={1} >
              <TableBody>
                <TableRow>
                {
              cols.map((col)=> <TableCell 
             
              sx={{minWidth:'120px'}} 
              key={col.keyRow}>
                {col.CustomRender({
                dataForm,
                value:item[col.keyRow],
                extraData:{...item},
                parentData:props.item,
                child_index,
                parentIndex:props.item_index,
                onChangeForm,
                onOpenDialog,
                })}
              </TableCell>
              
              ) 
            }
                </TableRow>
              </TableBody>
             </Table>
          </TableCell> )
        }
      </TableRow>
     
      </TableHead>
 </Table>

 </>
 
    )

}

